<template>
  <guest-layout>
    <template #header>
      Jadwal Beasiswa Cilegon Juare
    </template>
    <Head title="Jadwal Beasiswa Cilegon Juare" />
    <div class="container flex flex-wrap justify-between p-6 mx-auto my-4 mt-6 max-w-8xl">
      <div class="w-full overflow-hidden bg-white rounded-lg shadow-lg">
        <div class="p-6">
          <h2 class="mb-6 text-2xl font-bold text-gray-800">Jadwal Pelaksanaan</h2>

          <div v-if="schedule" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Kegiatan
                  </th>
                  <th scope="col" class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Hari/Tanggal
                  </th>
                  <th scope="col" class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Waktu
                  </th>
                  <th scope="col" class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Lokasi
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <span class="w-3 h-3 mr-3 bg-red-500 rounded-full"></span>
                      <span class="text-sm font-medium text-gray-900">Pendaftaran</span>
                    </div>
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.pendaftaran_tanggal }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.pendaftaran_waktu }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.pendaftaran_lokasi }}
                  </td>
                </tr>

                <tr>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <span class="w-3 h-3 mr-3 bg-orange-500 rounded-full"></span>
                      <span class="text-sm font-medium text-gray-900">Verifikasi</span>
                    </div>
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.verifikasi_tanggal }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.verifikasi_waktu }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.verifikasi_lokasi }}
                  </td>
                </tr>

                <tr>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <span class="w-3 h-3 mr-3 bg-green-500 rounded-full"></span>
                      <span class="text-sm font-medium text-gray-900">Pengumuman</span>
                    </div>
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.pengumuman_tanggal }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.pengumuman_waktu }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.pengumuman_lokasi }}
                  </td>
                </tr>

                <tr>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <span class="w-3 h-3 mr-3 bg-indigo-500 rounded-full"></span>
                      <span class="text-sm font-medium text-gray-900">Daftar Ulang </span>
                    </div>
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.daftar_ulang_tanggal }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.daftar_ulang_waktu }}
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ schedule.daftar_ulang_lokasi }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="py-8 text-center text-gray-500">
            Tidak ada jadwal beasiswa yang aktif saat ini.
          </div>
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import GuestLayout from '@/Layouts/GuestLayout.vue'

export default {
  components:{
    GuestLayout,
    Head,
  },
  props: {
    schedule: Object,
  },
}
</script>
